const doc = [({"en":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"rule":({"rule":"Rule", "enter_value":"Enter value"})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;